import React, { ReactNode, useContext, useState } from 'react';

import Header from '../components/Header';
import { SidebarV2 } from '../components/SidebarV2';
import BackgroundJobRail from '../components/BackgroundJobs/BackgroundJobRail';
import SidebarDesktopToggle from '../components/SidebarV2/SidebarDesktopToggle';
import LayoutPersistenceContext from './LayoutPersistenceContext';
import { getInitialSidebarExpanded } from '../utils/sidebarPreference';

interface POSLayoutProps {
  children: ReactNode;
}

const POSLayout: React.FC<POSLayoutProps> = ({ children }) => {
  const hasPersistentLayout = useContext(LayoutPersistenceContext);
  // =====================================================
  // 🔹 Mobile overlay
  // =====================================================
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // =====================================================
  // 🔹 Desktop compact/expanded
  // =====================================================
  const [sidebarExpanded, setSidebarExpanded] = useState(() =>
    getInitialSidebarExpanded(false)
  );

  if (hasPersistentLayout) return <>{children}</>;

  return (
    <LayoutPersistenceContext.Provider value>
      <div className="dark:bg-boxdark-2 dark:text-bodydark">
        <div className="relative flex h-screen overflow-hidden">
          {/* ===================================================== */}
          {/* 🔹 Sidebar */}
          {/* ===================================================== */}
          <SidebarV2
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarExpanded={sidebarExpanded}
            setSidebarExpanded={setSidebarExpanded}
            compactMode
          />

          <SidebarDesktopToggle
            expanded={sidebarExpanded}
            onToggle={() => setSidebarExpanded((expanded) => !expanded)}
            compactHeader
          />

          {/* ===================================================== */}
          {/* 🔹 Content */}
          {/* ===================================================== */}
          <div className="relative flex flex-1 flex-col overflow-hidden">
            {/* ===================================================== */}
            {/* 🔹 Header */}
            {/* ===================================================== */}
            <Header
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
              sidebarExpanded={sidebarExpanded}
              setSidebarExpanded={setSidebarExpanded}
              compactMode
            />

            {/* ===================================================== */}
            {/* 🔹 Main */}
            {/* ===================================================== */}
            <main className="bg-gray-50 flex-1 overflow-y-auto dark:bg-meta-4">
              <div className="h-full w-full p-3 md:p-4">{children}</div>
            </main>

            <BackgroundJobRail />
          </div>
        </div>
      </div>
    </LayoutPersistenceContext.Provider>
  );
};

export default POSLayout;
